import React, { useEffect, useState, useRef, useContext } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import GeneralSettings from "./generalSettings";
import GeneralSettingsAgentPreview from "./GeneralSettingsAgentPreview";
import TVAgentpreview from "./TVAgentpreview";

import { enableJira } from "../../../utils/config";
import { appLogger } from "../../../utils";
import MobilePreview from "./mobilePreview";

import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";

import RokuTv from "./TVComponents/RokuTv";
import Html5Tv from "./TVComponents/Html5Tv";

import {
  PLATFORM_TYPE_BROWSER,
  PLATFORM_TYPE_MOBILE,
  PLATFORM_TYPE_TV,
} from "../../../model";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function FAQ(props: any) {
  const { enabledFeatures } = useContext(UserContext) as UserLoginInfo;

  appLogger.info({
    infoObj: {
      method: "FAQ",
      component: "add-product",
      fileName: "faq.tsx",
      props: props,
    },
  });
  const widgetInfo = props.widgetAppearance?.widgetInfo;
  const [icon, setIcon] = useState("");
  // const icon = widgetInfo && widgetInfo.icon ? ("data:image/svg+xml;base64," + window.btoa(widgetInfo?.icon)) : ""

  useEffect(() => {
    if (widgetInfo && widgetInfo?.icon) {
      setIcon("data:image/svg+xml;base64," + window.btoa(widgetInfo?.icon));
    } else {
      setIcon("");
    }
    if (widgetInfo && widgetInfo?.btnPosition) {
      if (widgetInfo.btnPosition === "RIGHT_MIDDLE") {
        widgetInfo.customTop = "50%";
        widgetInfo.customBottom = "auto";
        widgetInfo.customLeft = "auto";
        widgetInfo.customRight = "0";
        widgetInfo.transformOrigin = "46px 18px";
        widgetInfo.margin = "0";
      } else if (widgetInfo.btnPosition === "RIGHT_BOTTOM") {
        widgetInfo.customTop = "auto";
        widgetInfo.customBottom = "0";
        widgetInfo.customLeft = "auto";
        widgetInfo.customRight = "0";
        widgetInfo.transformOrigin = "53px 10px";
        widgetInfo.margin = "0";
      } else if (widgetInfo.btnPosition === "LEFT_MIDDLE") {
        widgetInfo.customTop = "50%";
        widgetInfo.customBottom = "auto";
        widgetInfo.customLeft = "0";
        widgetInfo.customRight = "auto";
        widgetInfo.transformOrigin = "18px 18px";
        widgetInfo.margin = "0";
      } else if (widgetInfo.btnPosition === "LEFT_BOTTOM") {
        widgetInfo.customTop = "auto";
        widgetInfo.customBottom = "0";
        widgetInfo.customLeft = "0";
        widgetInfo.customRight = "auto";
        widgetInfo.transformOrigin = "10px 11px";
        widgetInfo.margin = "0";
      } else if (widgetInfo.btnPosition === "BOTTOM_RIGHT") {
        widgetInfo.customTop = "auto";
        widgetInfo.customBottom = "0";
        widgetInfo.customLeft = "auto";
        widgetInfo.customRight = "0";
        widgetInfo.transformOrigin = "unset";
        widgetInfo.margin = "0";
      } else if (widgetInfo.btnPosition === "BOTTOM_LEFT") {
        widgetInfo.customTop = "auto";
        widgetInfo.customBottom = "0";
        widgetInfo.customLeft = "0";
        widgetInfo.customRight = "auto";
        widgetInfo.transformOrigin = "unset";
        widgetInfo.margin = "0";
      }
    }
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "add-product",
        fileName: "faq.tsx",
        widgetInfo: widgetInfo,
      },
    });
  }, [widgetInfo?.btnPosition]);

  const basicRef = useRef<any>(null);
  const generalRef = useRef<any>(null);
  const bugRef = useRef<any>(null);
  const feedbackRef = useRef<any>(null);
  const extTrackerRef = useRef<any>(null);
  const featureRef = useRef<any>(null);
  const emailRef = useRef<any>(null);
  const widgetRef = useRef<any>(null);
  const widgetCodeRef = useRef<any>(null);
  const qrRef = useRef<any>(null);

  const basicPreviewRef = useRef<any>(null);
  const generalPreviewRef = useRef<any>(null);
  const bugPreviewRef = useRef<any>(null);
  const feedbackPreviewRef = useRef<any>(null);
  const extTrackerPreviewRef = useRef<any>(null);
  const featurePreviewRef = useRef<any>(null);
  const emailPreviewRef = useRef<any>(null);
  const widgetPreviewRef = useRef<any>(null);
  const qrCodePreviewRef = useRef<any>(null);
  const widgetCodePreviewRef = useRef<any>(null);

  const { scrollElement, previewScrollElement } = props;
  const [ClickedCatFbsVal, setClickedCatFbsVal] = React.useState([
    "Sign in perfect",
    "Preview looks good",
  ]);
  const [ClickedCat, setClickedCatVal] = React.useState("");

  const technology =
    props &&
    props.productParams &&
    props.productParams.products[0] &&
    props.productParams.products[0].technology;

  useEffect(() => {
    // if (scrollElement === "basic") {
    //   basicRef?.current?.scrollIntoView({ behavior: "smooth" });
    //   props.setScroll("");
    // } else
    if (scrollElement === "general") {
      generalRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "bug") {
      bugRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "feedback") {
      feedbackRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "feature") {
      featureRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "extTracker") {
      extTrackerRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "email") {
      emailRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "widget") {
      widgetRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "widgetCode") {
      widgetCodeRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    } else if (scrollElement === "qr") {
      qrRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setScroll("");
    }
  }, [props]);

  useEffect(() => {
    if (previewScrollElement === "general") {
      generalPreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    } else if (previewScrollElement === "bug") {
      bugPreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    } else if (previewScrollElement === "feedback") {
      feedbackPreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    } else if (previewScrollElement === "feature") {
      featurePreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    } else if (previewScrollElement === "widget") {
      widgetCodePreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    } else if (previewScrollElement === "qr") {
      qrCodePreviewRef?.current?.scrollIntoView({ behavior: "smooth" });
      props.setpreviewScroll("");
    }
  }, [props]);

  const setClickedCatFbsCb = (name: any) => {
    setClickedCatFbsVal(name);
  };
  const setClickedCat = (name: any) => {
    setClickedCatVal(name);
  };

  const renderIconContent = (icon: any) => {
    let content: any = "";
    if (icon == 2) {
      content = (
        <>
          <Box className="accordion-wrap" sx={{ mt: 2 }}>
            <Typography ref={generalRef}></Typography>
            <Typography className="title">How to configure</Typography>
            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel2-content"}
                id={"panel2-header"}
              >
                General Settings
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="730"
                  // src="https://di9fjq1qbn0zt.cloudfront.net/Help/generalsettings.html"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#general-settings"
                  // src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"
                ></iframe>
                {/* <p>
                  The fields in this section is to configure the common
                  features, text and screen design of the cuvo agent widget. The
                  label for the field tells what the purpose of the field is and
                  the preview area displays where on the widget screen it is
                  displayed or applies to. Most of the fields already have a
                  default value set. You can change it if you wish to. Set the
                  value of any text field as blank to not display any text in
                  that area.
                </p>
                {/*<p>
                <b>Title for the main widget screen:</b>
                <b>Subtitle below the main widget screen's title:</b>
                <b>Short thank you caption displayed after form submission:</b>
                <b>Maximum size of file to upload:</b>
                <b>Maximum duration of the Audio and Video recordings:</b>
                <b>How will the widget screen be invoked:</b>
                <b>Email field is mandatory:</b>
                <b>Show product logo on widget screen:</b>
                <b>Automatically capture user's system details:</b>
              </p>
                <p>
                  <b>What features of this widget would you use:</b> 'Submit
                  feedback' feature will allow your users to submit feedbacks
                  about your app/platform. 'Report bugs' feature will allow your
                  users report a bug in your app/platform. Select these feature
                  in the order in which you wish them to appear on the widget
                  screen. For example, if you want 'Submit feedback' to appear
                  first and then 'Report bugs', then first clear all your
                  selections and then select 'Submit feedback' and after that
                  select 'Report bugs'.
                </p>
                <p>
                  <b>How will the widget screen be invoked:</b>'User manually
                  clicks button' is the only option now.
                </p>
                <p>
                  <b>
                    Want to use your product's buttons or links to invoke the
                    widget screen:
                  </b>
                  Here you may add the details of the buttons or links that you
                  will use to invoke the Cuvo widget screen. You need to add
                  them here only if you want Cuvo to enable/disable these
                  buttons/links on your behalf.
                </p> */}
              </AccordionDetails>
              <Typography ref={feedbackRef}></Typography>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel3-content"}
                id={"panel3-header"}
              >
                Feedback Settings
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="980"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#feedback-settings"
                ></iframe>
              </AccordionDetails>
              <Typography ref={bugRef}></Typography>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel4-content"}
                id={"panel4-header"}
              >
                Ticket Settings
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="270"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#ticket-settings"
                ></iframe>
              </AccordionDetails>
              <Typography ref={featureRef}></Typography>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel4-content"}
                id={"panel4-header"}
              >
                Feature Request Settings
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="240"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#feature-request-settings"
                ></iframe>
              </AccordionDetails>
              <Typography ref={qrRef}></Typography>
              {/* <Typography ref={extTrackerRef}></Typography> */}
            </Accordion>
            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel2-content"}
                id={"panel2-header"}
              >
                QR Settings
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="730"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#qr-settings"
                ></iframe>
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel5-content"}
                id={"panel5-header"}
              >
                Widget Appearance
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="80"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#widget-appearance"
                  // src="https://di9fjq1qbn0zt.cloudfront.net/Help/basicdetails.html"
                  // src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"
                ></iframe>
              </AccordionDetails>
              <Typography ref={widgetRef}></Typography>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls={"panel5-content"}
                id={"panel5-header"}
              >
                Integration Steps
              </AccordionSummary>
              <AccordionDetails className="iframeaccdetails">
                <iframe
                  className="inlineIFrame"
                  id="inlineIFrame"
                  title="Inline Frame Examples"
                  width="100%"
                  frameBorder="0"
                  scrolling="yes"
                  height="300"
                  src="https://docs.cuvo.ai/configuring-cuvo-feedback#integratio-steps"
                  // src="https://di9fjq1qbn0zt.cloudfront.net/Help/basicdetails.html"
                  // src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"
                ></iframe>
              </AccordionDetails>
            </Accordion>
          </Box>
        </>
      );
    } else if (icon == 1) {
      if (props && props.productParams && props.productParams.products[0]) {
        content = (
          <>
            <GeneralSettingsAgentPreview
              productParams={props}
              generalPreviewRef={generalPreviewRef}
              feedbackPreviewRef={feedbackPreviewRef}
              bugPreviewRef={bugPreviewRef}
              featurePreviewRef={featurePreviewRef}
              widgetCodePreviewRef={widgetCodePreviewRef}
              widgetInfo={widgetInfo}
            />
          </>
        );
        if (props.productParams.products[0].platform === PLATFORM_TYPE_TV) {
          if (technology === "rokuTv") {
            content = (
              <RokuTv
                productParams={props}
                setClickedCatFbsCb={setClickedCatFbsCb}
                ClickedCatFbsVal={ClickedCatFbsVal}
                setClickedCat={setClickedCat}
                ClickedCat={ClickedCat}
                technology={technology}
                generalPreviewRef={generalPreviewRef}
                feedbackPreviewRef={feedbackPreviewRef}
                widgetCodePreviewRef={widgetCodePreviewRef}
                qrCodePreviewRef={qrCodePreviewRef}
              />
            );
          } else if (technology === "html5Tv") {
            content = (
              <Html5Tv
                productParams={props}
                setClickedCatFbsCb={setClickedCatFbsCb}
                ClickedCatFbsVal={ClickedCatFbsVal}
                setClickedCat={setClickedCat}
                ClickedCat={ClickedCat}
                technology={technology}
                generalPreviewRef={generalPreviewRef}
                feedbackPreviewRef={feedbackPreviewRef}
                widgetCodePreviewRef={widgetCodePreviewRef}
              />
            );
          } else {
            content = (
              <>
                <TVAgentpreview
                  productParams={props}
                  generalPreviewRef={generalPreviewRef}
                  feedbackPreviewRef={feedbackPreviewRef}
                  bugPreviewRef={bugPreviewRef}
                  featurePreviewRef={featurePreviewRef}
                  widgetCodePreviewRef={widgetCodePreviewRef}
                  widgetInfo={widgetInfo}
                  page={1}
                  setClickedCatFbsCb={setClickedCatFbsCb}
                  ClickedCatFbsVal={ClickedCatFbsVal}
                  setClickedCat={setClickedCat}
                  ClickedCat={ClickedCat}
                  technology={technology}
                />
                {/* <TVAgentpreview
                  productParams={props}
                  generalPreviewRef={generalPreviewRef}
                  feedbackPreviewRef={feedbackPreviewRef}
                  bugPreviewRef={bugPreviewRef}
                  featurePreviewRef={featurePreviewRef}
                  widgetCodePreviewRef={widgetCodePreviewRef}
                  widgetInfo={widgetInfo}
                  page={2}
                /> */}
                <TVAgentpreview
                  page={2}
                  productParams={props}
                  generalPreviewRef={generalPreviewRef}
                  feedbackPreviewRef={feedbackPreviewRef}
                  bugPreviewRef={bugPreviewRef}
                  featurePreviewRef={featurePreviewRef}
                  widgetCodePreviewRef={widgetCodePreviewRef}
                  widgetInfo={widgetInfo}
                  technology={technology}
                />
                <TVAgentpreview
                  page={3}
                  productParams={props}
                  generalPreviewRef={generalPreviewRef}
                  feedbackPreviewRef={feedbackPreviewRef}
                  bugPreviewRef={bugPreviewRef}
                  featurePreviewRef={featurePreviewRef}
                  widgetCodePreviewRef={widgetCodePreviewRef}
                  widgetInfo={widgetInfo}
                  setClickedCatFbsCb={setClickedCatFbsCb}
                  ClickedCatFbsVal={ClickedCatFbsVal}
                  setClickedCat={setClickedCat}
                  ClickedCat={ClickedCat}
                  technology={technology}
                />
                <TVAgentpreview
                  page={4}
                  productParams={props}
                  generalPreviewRef={generalPreviewRef}
                  feedbackPreviewRef={feedbackPreviewRef}
                  bugPreviewRef={bugPreviewRef}
                  featurePreviewRef={featurePreviewRef}
                  widgetCodePreviewRef={widgetCodePreviewRef}
                  widgetInfo={widgetInfo}
                  setClickedCatFbsCb={setClickedCatFbsCb}
                  ClickedCatFbsVal={ClickedCatFbsVal}
                  setClickedCat={setClickedCat}
                  ClickedCat={ClickedCat}
                  technology={technology}
                />
              </>
            );
          }
        } else if (
          props.productParams.products[0].platform === PLATFORM_TYPE_BROWSER
        ) {
          content = (
            <>
              <GeneralSettingsAgentPreview
                productParams={props}
                generalPreviewRef={generalPreviewRef}
                feedbackPreviewRef={feedbackPreviewRef}
                bugPreviewRef={bugPreviewRef}
                featurePreviewRef={featurePreviewRef}
                widgetCodePreviewRef={widgetCodePreviewRef}
                widgetInfo={widgetInfo}
              />
            </>
          );
        } else if (
          props.productParams.products[0].platform === PLATFORM_TYPE_MOBILE
        ) {
          content = (
            <MobilePreview
              productParams={props}
              generalPreviewRef={generalPreviewRef}
              feedbackPreviewRef={feedbackPreviewRef}
              bugPreviewRef={bugPreviewRef}
              featurePreviewRef={featurePreviewRef}
              widgetCodePreviewRef={widgetCodePreviewRef}
              widgetInfo={widgetInfo}
            />
          );
        }
      }
    }
    return content;
  };
  return (
    <Box style={{ width: "100%" }}>
      <div className="header-right-menu">
        <Typography className="title-sm">Configure Page</Typography>
        <CloseIcon
          className="cursor-pointer prod-faq-popup-close"
          onClick={props.handleClose}
        />
      </div>
      <div className="content-right-menu">
        <Typography className="info">
          {/* Product represents your software/platform/website with which you are
          integrating Cuvo agent with the aim to collect feedback/bug report
          from your customer and receive insights on those feedback/bug reports.
          You can control the look, behavior and placement of the cuvo agent by
          configuring it on this product page. After your configuration follow
          the integration instructions at the end of the page to integrate with
          your software/platform/website. Refer to the following sections for
          help on how to configure Cuvo agent. */}
        </Typography>
        {renderIconContent(props.contentType)}
      </div>
    </Box>
  );
}

export default FAQ;
